import React, { useState, useEffect } from 'react'
import Card from '../components/Card'

const Projects = () => {
  const [showPopup, setShowPopup] = useState(false)
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    setShowPopup(true)
    const duration = 5000 
    const interval = 50 
    const steps = duration / interval
    let currentStep = 0

    const timer = setInterval(() => {
      currentStep++
      setProgress((currentStep / steps) * 100)
      
      if (currentStep >= steps) {
        clearInterval(timer)
        setShowPopup(false)
      }
    }, interval)

    return () => clearInterval(timer)
  }, [])

  const getColor = (progress) => {
    if (progress < 50) return `rgb(${progress * 2.55}, 255, 0)`
    return `rgb(255, ${255 - (progress - 50) * 5.1}, 0)`
  }

  return (
    <div className='flex flex-col items-center ml-0 lg:ml-[18em] justify-center min-h-screen overflow-x-hidden px-4 lg:px-0'>
      <Card />
      {showPopup && (
        <div className='fixed bottom-6 right-4 bg-white border border-gray-200 rounded-lg shadow-lg p-3 max-w-xs transition-all duration-300 ease-in-out'>
          <p className='text-sm font-suwannaphum text-gray-700 mb-2'>
            Projects can be live previewed or have code available.
          </p>
          <div className='w-full h-1 bg-gray-200 rounded-full overflow-hidden'>
            <div 
              className='h-full transition-all duration-50 ease-linear'
              style={{ 
                width: `${progress}%`,
                backgroundColor: getColor(progress)
              }}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default Projects